<script>
  import { loop_guard } from "svelte/internal";
  export let promise;

  let catinfo;
  promise.then(() => {
    catinfo = categoryInfo.subCategory;
  });

  /*
  ------------------------------------------
    リンクのアクティブ判定
  -----------------------------------------
  */
  const isActive = (index) => {
    if (location.href.indexOf("subcat") !== -1) {
      const subcatNum = Number(location.href.split("subcat=")[1]);
      if (subcatNum === index) {
        return "active";
      }
    } else {
      if (index === 0) {
        return "active";
      }
    }
  };
  /*
  ------------------------------------------
    サブカテゴリのリンクを生成
  -----------------------------------------
  */
  const createSubCategoryLink = (index) => {
    let href = `/?shopbrand=${shopBrand}`;
    return `${href}&subcat=${index}`;
  };
</script>

{#await promise then response}
  {#each catinfo as item, index}
    <li>
      <a href={createSubCategoryLink(index)} class={isActive(index)} data-category={index}>
        {item}
      </a>
    </li>
  {/each}
{/await}
